// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchNotification_root__qKyB1"};